import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KaterineMontoya from "../pages/katerine-montoya/page";
import MiguelAndrade from "../pages/miguel-andrade/page";
import FernandoBonilla from "../pages/fernando-bonilla/page";
import DavidRoldan from "../pages/david-roldan/page";
import Gustavo from "../pages/gustavo/page";
import DanielBallesteros from "../pages/daniel-ballesteros/page";
import Roman from "../pages/roman/page";
import LandingPage from "../pages/landing/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/katerine-montoya",
    element: <KaterineMontoya />,
  },
  {
    path: "/miguel-andrade",
    element: <MiguelAndrade />,
  },
  {
    path: "/fernando-bonilla",
    element: <FernandoBonilla />,
  },
  {
    path: "/david-roldan",
    element: <DavidRoldan />,
  },
  {
    path: "/gustavo",
    element: <Gustavo />,
  },
  {
    path: "/daniel-ballesteros",
    element: <DanielBallesteros />,
  },
  {
    path: "/roman",
    element: <Roman />,
  },
  {
    path: "/juan-jose/:id",
    element: <LandingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;